import { ReactNode } from 'react';
import { IAdBlock, getAdBlockGridIndex } from '../AdBlockCard';


export const interleaveAdBlocks = (
  items: ReactNode[],
  adBlocks: IAdBlock[],
  renderAd: (block: IAdBlock, key: string) => ReactNode,
): ReactNode[] => {
  if (!adBlocks.length) return items;

  const sorted = [...adBlocks].sort(
    (a, b) => getAdBlockGridIndex(a) - getAdBlockGridIndex(b),
  );
  const maxGridIndex = sorted.reduce(
    (max, b) => Math.max(max, getAdBlockGridIndex(b)),
    -1,
  );
  const totalSlots = Math.max(items.length + sorted.length, maxGridIndex + 1);

  const result: ReactNode[] = [];
  let srcIndex = 0;

  for (let gridIndex = 0; gridIndex < totalSlots; gridIndex++) {
    const adsAtPosition = sorted.filter((b) => getAdBlockGridIndex(b) === gridIndex);
    if (adsAtPosition.length) {
      adsAtPosition.forEach((block, i) =>
        result.push(renderAd(block, `ad-block-card-${gridIndex}-${i}`)),
      );
    } else if (srcIndex < items.length) {
      result.push(items[srcIndex++]);
    }
  }

  while (srcIndex < items.length) {
    result.push(items[srcIndex++]);
  }

  return result;
};
import { ReactNode } from 'react';
import { IAdBlock, getAdBlockGridIndex } from '../AdBlockCard';


export const interleaveAdBlocks = (
  items: ReactNode[],
  adBlocks: IAdBlock[],
  renderAd: (block: IAdBlock, key: string) => ReactNode,
): ReactNode[] => {
  if (!adBlocks.length) return items;

  const sorted = [...adBlocks].sort(
    (a, b) => getAdBlockGridIndex(a) - getAdBlockGridIndex(b),
  );
  const maxGridIndex = sorted.reduce(
    (max, b) => Math.max(max, getAdBlockGridIndex(b)),
    -1,
  );
  const totalSlots = Math.max(items.length + sorted.length, maxGridIndex + 1);

  const result: ReactNode[] = [];
  let srcIndex = 0;

  for (let gridIndex = 0; gridIndex < totalSlots; gridIndex++) {
    const adsAtPosition = sorted.filter((b) => getAdBlockGridIndex(b) === gridIndex);
    if (adsAtPosition.length) {
      adsAtPosition.forEach((block, i) =>
        result.push(renderAd(block, `ad-block-card-${gridIndex}-${i}`)),
      );
    } else if (srcIndex < items.length) {
      result.push(items[srcIndex++]);
    }
  }

  while (srcIndex < items.length) {
    result.push(items[srcIndex++]);
  }

  return result;
};
